import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 2H1.5V22.7038L6.87574 18H22.5V2ZM8.28788 6.55546C9.30471 5.53862 10.9197 5.48455 12.0002 6.39325C13.0806 5.48455 14.6957 5.53862 15.7125 6.55546C16.7864 7.6294 16.7864 9.3706 15.7125 10.4445L12.0002 14.1569L8.28788 10.4445C7.21394 9.3706 7.21394 7.6294 8.28788 6.55546Z"}}]};

const ChatHeartFilled = Vue.extend<IconProps>({
  name: 'ChatHeartFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chat-heart-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChatHeartFilled;
